import { AsyncActions } from '../../standard-actions';
import { IServiceRequestsState } from '.';
export const initialState: IServiceRequestsState = {
    all: {
        data: {
            items: [],
            pagination: {
                updatedBeforeCursor: null
            },
            metaData: {
                totalCount: ''
            }
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    allInternetProducts: {
        data: {
            items: [],
            pagination: {
                updatedBeforeCursor: null
            },
            metaData: {
                totalCount: ''
            }
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    open: {
        data: {
            items: [],
            pagination: {
                cursor: null
            }
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    closed: {
        data: {
            items: [],
            pagination: {
                cursor: null
            }
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    allMaxim: {
        data: {
            items: [],
            pagination: {
                cursor: null
            }
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    maximActivities: {
        data: {
            activities: [],
            totalCount: '',
            pagination: {
                pageIndex: 1,
                pageSize: 25,
                sortByOrder: '',
                sortBy: ''
            }
        },
        companyId: '',
        status: AsyncActions.AsyncActionState.NotStarted
    },
    summary: {
        data: {
            openServiceRequests: 0,
            closedServiceRequests: 0,
            customerPendingServiceRequests: 0,
            onHoldServiceRequests: 0,
            onTrackServiceRequests: 0,
            delayedServiceRequests: 0
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    requestsCategory: {
        items: [],
        categoryCount: 0,
        status: AsyncActions.AsyncActionState.NotStarted
    },
    requestsCategories: {
        items: [],
        status: AsyncActions.AsyncActionState.NotStarted
    },
    requestCategoryItems: {
        items: [],
        status: AsyncActions.AsyncActionState.NotStarted
    },
    requestCategoryItemQuestions: {
        items: [],
        status: AsyncActions.AsyncActionState.NotStarted
    },

    requestCategoryWithItemQuestions: {
        items: [],
        metaData: {
            chargeId: '',
            host: '',
            resource: ''
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    requestCategoryDeacItemQuestions: {
        items: [],
        metaData: {
            chargeId: '',
            host: '',
            resource: ''
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    requestCategoryWithItems: {
        items: [],
        status: AsyncActions.AsyncActionState.NotStarted
    },
    createServiceRequest: {
        status: AsyncActions.AsyncActionState.NotStarted
    },
    serviceRequestDetails: {
        status: AsyncActions.AsyncActionState.NotStarted
    },
    serviceRequestActivityDetails: {
        status: AsyncActions.AsyncActionState.NotStarted
    },
    serviceRequestDomesticActivities: {
        items: [],
        status: AsyncActions.AsyncActionState.NotStarted
    },
    fileUploads: {
        data: [],
        status: AsyncActions.AsyncActionState.NotStarted
    },
    addComment: {
        status: AsyncActions.AsyncActionState.NotStarted
    },
    customerReference: {
        status: AsyncActions.AsyncActionState.NotStarted
    },
    deviceTypeData: {
        data: {
            deviceTypeList: [],
            lastSynced: null,
            sort: ''
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    deviceSummaryData: {
        data: {
            totalDevices: 0,
            enroled: 0,
            unEnroled: 0,
            otherDevices: 0,
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    deviceChargeableData: {
        data: {
            chargeable: 0
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    enrollHistoryData: {
        data: {
            pastWeek: 0,
            pastMonth: 0,
            thirtyPlus: 0
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    search: {
        locations: {
            original: {
                location: []
            },
            filters: {
                location: []
            }
        }
    },
    deviceInformation: {
        data: {
            deviceDetails: {
                device: null,
                IMEI: null,
                mdmOwnershipType: null,
                lastSeenDate: null
            },
            planDetails: {
                chargeable: null,
                planType: null
            },
            complianceDetails: {
                policyName: null,
                complianceStatus: null,
                policyDetails: null,
                lastCompliance: null,
                NextCompliance: null
            },
            enrollmentStatus: null
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    tenancyDetails: {
        data: {
            tenancyDetails: null
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    userDetail: {
        data: {
            firstName: null,
            lastName: null,
            email: null,
            userName: null
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    getUserDynamic: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    topTenAppsTypeData: {
        data: {
            applicationList: [],
            originaltopTenAppsTypeList: [],
            sort: ''
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    mobileServicesData: {
        data: {
            serviceList: [],
            countOfServices: null
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    strategicDeviceDetailsData: {
        data: {
            serviceNumber: null
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    strategicSimConfigInfoData: {
        data: {
            serviceInfo: null
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    featureFlagsData: {
        data: {
            accessToDownloadAttachments: false,
            isStrategicUser: false,
            viewAggregatedYPSpage: false,
            isInternationalViaIRL: false
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    fncServiceListDetails: {
        data: {
            serviceListItems: []
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    nbnServiceListDetails: {
        data: {
            nbnServices: [],
            pagination: {
                totalCount: 0,
                pageSize: 0,
                pageIndex: 1
            },
            toast: {
                data: []
            },
            testCounter: 1,
            pageIndexList: [

            ],
            callApiPosition: 1,
            currentPage: 0
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    nbnTestRequest: {
        data:
            [
                {
                    diagnosticName: '',
                    diagnosticStatus: '',
                    diagnosticStartTime: '',
                    estimatedDurationMs: 0,
                    diagnosticTestMessage: '',
                    services: [
                        {
                            serviceId: '',
                            serviceType: ''
                        }
                    ]
                }

            ],
        status: AsyncActions.AsyncActionState.NotStarted
    },
    nbnresults: {
        data: [
            {}
        ],
        status: AsyncActions.AsyncActionState.NotStarted

    },
    userProfileDetails: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    fncRequestTypeDetails: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            changeTables: [],
            changeType: '',
            product: '',
        }
    },
    ypsProductFamiliesRequest: {
        data: null,
        status: AsyncActions.AsyncActionState.NotStarted
    },
    fncProductCatalogue: {
        data: [],
        status: AsyncActions.AsyncActionState.NotStarted
    },
    fncRequests: {
        data: null,
        status: AsyncActions.AsyncActionState.NotStarted
    },
    validateSimDetails: {
        data: null,
        status: AsyncActions.AsyncActionState.NotStarted
    },
    fncFnnValidationDetails: {
        data: null,
        status: AsyncActions.AsyncActionState.NotStarted
    },
    covid19RequestFlag: false,
    company: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            data: []
        }
    },
    nbnHistoryDetails: {
        data: {},
        status: AsyncActions.AsyncActionState.NotStarted
    },
    listOfAttachments: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            related_entity: []
        }
    },
    deleteFileAttachments: {
        data: [],
        status: AsyncActions.AsyncActionState.NotStarted
    },
    downloadAttachment: {
        status: AsyncActions.AsyncActionState.NotStarted
    },
    smServiceId: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            companyId: '',
            selectedCompanyId: [],
            serviceIdsList: []
        }
    },
    maximDetails: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            billingAccount: '',
            serviceNumber: '',
            product: '',
            description: '',
            requestedByName: '',
            contactPhone: '',
            contactEmail: '',
            requesterNameOnBehalf: '',
            requesterContactOnBehalf: '',
            requesterEmailOnBehalf: '',
            submittedDate: '',
            lastUpdatedDate: '',
            status: '',
            customerReferenceNumber: '',
            formData: [],
            attachments: []
        }
    },
    customerContact: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            data: [],
            status: 200
        },
    },
    deliveryAddressAutoSearch: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            addresses: []
        }
    },
    addressSimplified: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            simplifiedAddresses: []
        }
    },
    advancedAddress: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            simplifiedAddresses: []
        }
    },
    apnList: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            shared: [],
            dedicated: []
        }
    },
    cidnAssociatedToService: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: []
    },
    nitServiceList: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            location: [],
            serviceType: [],
            status: []
        }
    },
    trackingPageStates: {
        selectedTab: ''
    },
    mobileServicesList: {
        data: {
            serviceList: [],
            count: 0
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    tonSubscriptionDetails: {
        data: {
            tonSubscriptionDetail: {
                currentStatus: '',
                devicePaired: ''
            }
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    mobileServicesDetailStrategic: {
        data: {
            details: null,
            deviceConfig: null
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    mobileServiceLegacyETC: {
        data: {
            totalEtcAmountIncludingGst: null,
            etcChargeDetails: null
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    earlyTerminationChargesDetails: {
        data: {
            earlyTerminationChargesDetail: {
                totalEtcAmountExcludingGst: '',
                totalEtcAmountIncludingGst: '',
                etcChargeDetails: [
                    {
                        payoutAmount: '',
                        agreementEndDate: ''
                    }
                ]
            }
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    adaptiveMobilityPlanDetails: {
        data: {
            adaptiveMobilityPlanDetail: {
                priceDetails: [
                    {
                        productCode: '',
                        standardPrice: 0,
                        discountedPrice: 0,
                        isGSTIncluded: false,
                        ChargeType: '',
                        shortDescription: '',
                        billing_spec_id: '',
                        name: '',
                        related_product_model: ''
                    }
                ]
            }
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    addOnsDetails: {
        data: {
            priceDetails: [
                {
                    standardPrice: '',
                    discountedPrice: '',
                    shortDescription: '',
                    name: '',
                    current: false,
                    installStatus: ''
                }
            ]
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    metaData: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            chargeId: '',
            host: '',
            resource: ''
        },
    },
    irMonthPassAddOnsDetails: {
        data: {
            priceDetails: [
                {
                    standardPrice: '',
                    discountedPrice: '',
                    currentStatus: '',
                    installStatus: ''
                }
            ]
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    acceleratorAddOnsDetailsRequest: {
        data: {
            priceDetails: [
                {
                    standardPrice: '',
                    discountedPrice: '',
                    currentStatus: '',
                    addOn: [],
                    installStatus: ''
                }
            ]
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
    servicesSummary: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            numberOfServices: 0,
            numberOfOptimals: 0,
            numberOfIssues: 0,
            optimalAvailability: 0,
            issuesAvailability: 0,
            numberOfPlannedMaintenanceServices: 0,
        },
    },
    manageDirectoryListing: {
        data: {
            directoryListingDetails: {
                listingLabel: '',
                description: '',
                status: ''
            }

        },
        status: AsyncActions.AsyncActionState.NotStarted,
    },
    internetProductDetails: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            requestDetail: {
                requestNumber: '',
                requestType: '',
                status: '',
                submitted: '',
                requestedBy: '',
                productType: '',
                asNumber: '',
                maintainedBy: '',
                description: ''
            },
            prefixList: [],
            metaData: {
                totalCount: 0
            }
        }
    },
    internetProductDnsDetails: {
        status: AsyncActions.AsyncActionState.NotStarted
    },
    allDnsIntenetProducts: {
        data: {
            items: [],
            pagination: {
                updatedBeforeCursor: null
            },
            metaData: {
                totalCount: ''
            }
        },
        status: AsyncActions.AsyncActionState.NotStarted
    },
}
